import React, { Component } from 'react';
import { Switch,Route } from 'react-router-dom';

//数据管理 车辆档案
import DataFire from './article';

class ReLayout extends Component {

  render(){

    const match = this.props.match;

    return(<Switch>
      {/*<Route path={match.url+'/data'} component={DataFire}/>*/}
      <DataFire/>
    </Switch>)
  }

}

export default ReLayout;
